function openSiteItem(siteId) {

    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnGoToSiteFromShortcut', parseInt(siteId));
   // RedirectTo("operation/" + siteId);
}